import React from 'react'

import { PatientMedicalSummaryRailContent } from './PatientMedicalSummaryRailContent'

import styles from './PatientMedicalSummaryRail.module.scss'

interface PatientMedicalSummaryRailProps {
  clientId: string
  patientId: string
}

export const PatientMedicalSummaryRail = ({
  clientId,
  patientId,
}: PatientMedicalSummaryRailProps) => (
  <div className={styles.railContainer}>
    <PatientMedicalSummaryRailContent
      clientId={clientId}
      patientId={patientId}
    />
  </div>
)
